module.exports = __webpack_public_path__ + "static/media/Group.073afec1.svg";